import Reveal from "./Reveal";
import { PARTNERS } from "../../data/pwt";
import { ArrowUpRight } from "lucide-react";

export default function Partners() {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative py-24 md:py-32 bg-[#0A140F] text-white overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#1A402B] opacity-40 blur-3xl"
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-20">
          <Reveal className="col-span-12 md:col-span-6">
            <span className="overline text-[#D8E2DC]">05 — The ecosystem partners (so far)</span>
            <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">
              Boutique firms,
              <br />
              <span className="italic text-[#D8E2DC]">one ecosystem.</span>
            </h2>
          </Reveal>
          <Reveal className="col-span-12 md:col-span-6 md:pt-6" delay={120}>
            <p className="font-sans text-lg leading-relaxed text-white/70">
              The growing list of independent firms that operate together within PWT —
              each excellent in its own capability area.
            </p>
          </Reveal>
        </div>

        {/* Marquee */}
        <Reveal delay={120}>
          <div className="relative overflow-hidden border-y border-white/15 py-6">
            <div className="flex marquee-track gap-16 w-max">
              {[...PARTNERS, ...PARTNERS].map((p, i) => (
                <span
                  key={`m-${i}`}
                  className="font-serif text-3xl md:text-5xl italic text-white/85 whitespace-nowrap"
                >
                  {p.name}
                  <span className="text-[#D8E2DC] not-italic font-sans text-base align-middle mx-6">
                    ·
                  </span>
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        {/* Grid of names */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/15 border border-white/15">
          {PARTNERS.map((p, i) => (
            <Reveal
              key={p.name}
              delay={i * 50}
              data-testid={`partner-card-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
              className="bg-[#0A140F]"
            >
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`partner-link-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
                className="group relative block p-8 md:p-10 h-full hover:bg-[#1A402B] transition-colors"
              >
                <ArrowUpRight
                  size={20}
                  strokeWidth={1.5}
                  className="absolute top-6 right-6 text-white/40 group-hover:text-white group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                />
                <div className="overline text-[#D8E2DC]">Capability area</div>
                <div className="mt-3 font-sans text-sm text-white/70 group-hover:text-white/90 transition-colors">
                  {p.focus}
                </div>
                <div className="mt-5 font-serif text-3xl md:text-4xl leading-tight">
                  {p.name}
                </div>
                <div className="mt-6 font-mono text-[0.65rem] uppercase tracking-[0.22em] text-white/40">
                  Partner / {String(i + 1).padStart(2, "0")}
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
